import { EventBus } from '../../../event';
import { Tags } from '../../../web';
import { Interceptor, IResponse } from '../http.service';
import { isRequestTimeouted } from './timeout-request-interceptor';

export const RequestStatusCode403OccuredEvent = Symbol('shared:request-status-code-401-occured');

export function handle403StatusRequestInterceptor(): Interceptor {
    return {
        responseError: (error: IResponse) => {
            if (!isRequestTimeouted(error) && error.config?.taggedUrl?.hasAnyTag([Tags.Api, Tags.SelloApi]) && error.response?.status === 403) {
                EventBus.emit(RequestStatusCode403OccuredEvent);
            }
        }
    };
}
